// extracted by css-extract-rspack-plugin
export default {"search":"Search__search--WliHE","searchContainer":"Search__searchContainer--cVG9U","icon":"Search__icon--F4YuT"};